import { render, staticRenderFns } from "./RadioItemForm.vue?vue&type=template&id=2e479a03&"
import script from "./RadioItemForm.vue?vue&type=script&lang=js&"
export * from "./RadioItemForm.vue?vue&type=script&lang=js&"
import style0 from "./RadioItemForm.vue?vue&type=style&index=0&id=2e479a03&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports